import { Component, OnInit } from '@angular/core';
import { CommonService } from '../../services/common.service';
import { FormGroup, FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { AuthService } from '../../services/auth.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ValidationService } from '../../services/validation.service';
import { PagerService } from '../../services/index';
import * as $ from 'jquery/dist/jquery.min.js';
declare var jQuery: any;


@Component({
	selector: 'app-time',
	templateUrl: './time.component.html',
	styleUrls: ['./time.component.css']
})
export class TimeComponent implements OnInit {
	timeForm: FormGroup;
	pager: any = {};
	pagedItems: any[];
	total: any;
	limit: any;
	pageNo: any;
	searchStr: any = '';
	modalTitle: any;
	timeList: any
	btnTitle: any;
	selectedTimeId: any;
	isTimeAvailable: boolean = true;
	isActivatedAdd: boolean = false;
	isActivatedEdit: boolean = false;
	isActivatedDelete: boolean = false;
	constructor(private commonService: CommonService, private authService: AuthService,
		private router: Router, private validationService: ValidationService,
		private pagerService: PagerService) { }

	ngOnInit() {
		$(".navbar-brand").text("Time");
		this.timeForm = new FormGroup({
			time: new FormControl("", Validators.compose([
				Validators.required,
			])),
			businessCharge: new FormControl("", Validators.compose([
				Validators.required,
			])),
		});

		this.pageNo = 1;
		this.limit = 10;
		this.getTimeList(this.pageNo, this.limit, this.searchStr)
	}

	//Get Time list
	getTimeList = function (pageNo, limit, searchStr) {

		this.commonService.process();

		this.authService.getTimeList(pageNo, limit, searchStr).subscribe(data => {

			if (data.success) {
				this.timeList = data.time;
				this.isTimeAvailable = true;
				this.total = data.total;
				this.setPage(pageNo, true);
				this.pageNo = pageNo;
			}
			else {
				this.isTimeAvailable = false;
				this.timeList = [];
			}
			this.commonService.hideProcess();
		})
	}

	// Pagination
	setPage(page: number, param) {

		if (page < 1 || page > this.pager.totalPages) {
			return;
		}
		//this.pageNo = page;
		this.pager = this.pagerService.getPager(this.total, page);

		// get current page of items
		this.pagedItems = this.timeList.slice(this.pager.startIndex, this.pager.endIndex + 1);
		if (!param) {
			this.getTimeList(page, this.limit, this.searchStr);
		}
	}

	// Add Time
	addTime = function () {
		this.isActivatedAdd = true;
		this.isActivatedEdit = false;
		this.isActivatedDelete = false;
		this.modalTitle = "Add Time";
		this.btnTitle = "Save";
		this.timeForm.reset();
	}

	// Update selected time
	updateSelectedTime = function (time) {
		this.isActivatedAdd = false;
		this.isActivatedEdit = true;
		this.isActivatedDelete = false;
		this.modalTitle = "Update Time";
		this.btnTitle = "Update";
		this.selectedTimeId = time._id;
		this.timeForm.controls['time'].setValue(time.time);
		this.timeForm.controls['businessCharge'].setValue(time.businessCharge);
	}

	// Delete Selected time
	deleteSelectedTime = function (time) {
		this.isActivatedAdd = false;
		this.isActivatedEdit = false;
		this.isActivatedDelete = true;
		this.modalTitle = "Delete Time";
		this.btnTitle = "Yes";
		this.selectedTimeId = time._id;
		this.time = time;
	}

	// manage new time
	manageTime = function (timeForm,) {

		if (this.timeForm.valid && this.isActivatedAdd) {
			this.btnTitle = "Saving...";
			jQuery(':button[type="submit"]').attr('disabled', true);
			this.authService.manageTime(timeForm, "add").subscribe(data => {
				if (data.success) {
					jQuery.growl.notice({ title: 'Success', message: data.message });
					this.getTimeList(1, this.limit, this.searchStr);
				}
				else {
					jQuery.growl.error({ title: 'Error', message: data.error });
				}
				jQuery(':button[type="submit"]').attr('disabled', false);
				this.authService.cancelProcess();
			});
		}
		else if (this.timeForm.valid && this.isActivatedEdit) {
			timeForm._id = this.selectedTimeId;
			this.btnTitle = "Updating...";
			jQuery(':button[type="submit"]').attr('disabled', true);
			this.authService.manageTime(timeForm, "edit", this.selectedTimeId).subscribe(data => {
				if (data.success) {
					this.getTimeList(this.pageNo, this.limit, this.searchStr);
					jQuery.growl.notice({ title: 'Success', message: data.message });
				}
				else {
					jQuery.growl.error({ title: 'Error', message: data.error });
				}
				jQuery(':button[type="submit"]').attr('disabled', false);
				this.authService.cancelProcess();
			});
		}
		else if (this.isActivatedDelete) {
			timeForm._id = this.selectedTimeId;
			this.btnTitle = "Deleting...";
			jQuery(':button[type="submit"]').attr('disabled', true);
			this.authService.manageTime(timeForm, "delete", this.selectedTimeId).subscribe(data => {
				if (data.success) {

					this.getTimeList(this.pageNo, this.limit, this.searchStr);
					jQuery.growl.notice({ title: 'Success', message: data.message });
				}
				else {
					jQuery.growl.error({ title: 'Error', message: data.error });
				}
				jQuery(':button[type="submit"]').attr('disabled', false);
				this.authService.cancelProcess();
			});
		}
		else {
			this.validationService.validateAllFormFields(this.timeForm);
		}
	}

	// Search Time
	searchTime = function () {
		this.searchStr = jQuery("#search").val();
		this.getTimeList(1, this.limit, this.searchStr);
	}
}


// WEBPACK FOOTER //
// /Users/vishitamandloi/Documents/vishitaProjects/waz/angular/adminportal/waz-admin-panel/src/app/dashboard/time/time.component.ts